export const GoodsFormOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: false,
  showHeader: true,
  // align: 'center',
  index: false,
  selection: true,
  menu: true,
  page: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  columnBtn: false,
  //viewBtn: true,
  menuWidth: "200",
  labelWidth: "150",
  defaultSort: {
    prop: "createTime",
    order: "descending",
  },
  column: [
    {
      label: "产品名称",
      prop: "name",
      type: "input",
      search: true,
      span: 13,
      placeholder: "请选择客户端类型",
    },
    // price
    {
      label: "产品价格",
      prop: "price",
      type: "input",
      span: 13,
      placeholder: "请输入产品价格",
    },
    // shopPrice经销商价格
    {
      label: "经销商价格",
      prop: "shopPrice",
      type: "input",
      span: 13,
      placeholder: "请输入经销商价格",
    },
    //rebate返利金额
    {
      label: "返利金额",
      prop: "rebate",
      type: "input",
      span: 13,
      placeholder: "请输入返利金额",
    },
    // 创建时间
    {
      label: "创建时间",
      prop: "createTime",
      type: "datetime",
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      // search: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "创建人",
      prop: "createBy",
      type: "input",
      search: true,
      addVisdiplay: false,
      editVisdiplay: false,
      width: "110",
    },
    {
      label: "更新时间",
      prop: "updateTime",
      type: "datetime",
      // search: true,
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      addVisdiplay: false,
      editVisdiplay: false,
    },

    {
      label: "更新人",
      prop: "updateBy",
      type: "input",
      search: true,
      addVisdiplay: false,
      editVisdiplay: false,
      width: "110",
    },
  ],
};
